export interface MedidasProductosPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: MEDIDASPRODUCTOS[];
}

/* export interface MEDIDASPRODUCTOS {
  id_medida_producto?: number;
  nombre: string;
  nomengratura: string;
  estado: boolean;
} */

export interface MEDIDASPRODUCTOS {
  id_unidad_medida: string
  codigo: string
  numero_referencia: string
  nombre: string
  siglas: string
  estado: boolean
  fecha_creacion: string
  fecha_modificacion: string
}

export enum MedidasProductosEnum {
  METROS = 'METROS',
  UNIDADES = 'UNIDADES',
}